import axios from '../../shared/axiosConfig';

export const ProfileActions = {
  SET_ATTRIBUTE: "PROFILE_SET_ATTRIBUTE"
};

/**
 * @param {String} key
 * @param {*} value
 */
export const setProfileAttribute = (key, value) => {
  return {
    type: ProfileActions.SET_ATTRIBUTE,
    key,
    value
  };
};

export const setInProgress = (state) => setProfileAttribute('inProgress', state);
export const setError = (error) => setProfileAttribute('error', error);
export const setLoaded = (state) => setProfileAttribute('loaded', state);

export const fetchProfile = () => async (dispatch) => {
  console.log("Getting jobseeker profile");
  dispatch( setLoaded(false) );
  await axios.get('/api/jobseeker')
    .then( (res) => {
      console.log("Received profile", res.data);
      dispatch( setProfileAttribute('data', res.data) );
      dispatch( setLoaded(true) );
    })
    .catch( function(err) {
      console.log(err);
      dispatch( setError(err) );
    });
}

export const submitProfile = () => async (dispatch, getState) => {
  let profile = getState().form.profile.values;
  let eventId = getState().event.eventId;

  let data = new FormData();
  for(var key in profile) {
    if((typeof profile[key]  === 'object')&&( key != 'resume' ) ) {
      profile[key] = JSON.stringify(profile[key]);
    }
    if( profile[key] && ( !profile[key]['url'] ) ) {
      data.append(key, profile[key]);
    }
  }
  data.append('event_id', eventId);

  console.log("Sumbitting jobseeker profile", profile);
  dispatch( setInProgress(true) );
  await axios.post('/api/jobseeker', data)
    .then( async (res) => {
      console.log("Upload completed");
      await dispatch( fetchProfile() );
      dispatch( setInProgress(false) );
      dispatch( setProfileAttribute( 'successful', true ) );
    })
    .catch( function(err) {
      console.log(err.response.data);
      if( err.response.data.error.passed === false ) {
        dispatch( setProfileAttribute( 'failedAnswers', true) );
        dispatch( setInProgress(false) );
        return;
      }
      console.log(err);
      dispatch( setInProgress(false) );
      dispatch( setError(err) );
    });
}
